<template>
  <b-form-row>
    <b-modal
    @hidden="cancelar"
      size="xl"
      button-size="sm"
      ref="finder"
      hide-footer
      :id="this.id"
      :title="prefix + title"
    >
      <grupo-produto-list
        @onDblClickGrupo="grupoSelect"
        :title="prefix + title + '>'"
        :visible="visible"
        :addBtnVisible="false"
      />
    </b-modal>

    <lg-form-input-finder
      v-model="localValue"
      fieldDescription="descricao"
      :label="label"
      invalidFeedback="Grupo deve ser informado!"
      description=""
      :showClear="showClear"
      @handleClean="grupoSelect"
    >
      <template #prepend>
        <b-button
          @click="show"
          class="btn-input-finder"
          pressed
          v-if="user !== null"
          :disabled="disabled"
        >
          <b-icon icon="search" />
        </b-button>
      </template>
    </lg-form-input-finder>
  </b-form-row>
</template>

<script>
import LgFormInputFinder from "@/core/components/Form/LgFormInputFinder.vue"
import GrupoProdutoList from "../../modules/cadastros/grupo-produto/GrupoProdutoList.vue"

export default {
  components: { LgFormInputFinder, GrupoProdutoList },

  props: {
    id: String,
    user: Object,
    value: Object,
    disabled: {
      type: Boolean,
      default: false,
    },
    prefix: {
      type: String,
      default: "",
    },
    visible: {
      type: Boolean,
      default: true,
    },
    showClear: {
      type: Boolean,
      default: true,
    },
    label: {
      type: String,
      default: "Grupo:",
    },
  },

  data() {
    return {
      localValue: this.value,
      descricao: "",
      title: "Grupo",
    }
  },

  watch: {
    value(newValue) {
      this.localValue = newValue
    },
  },

  methods: {
    async load() {
      let filtro = ""

      if (this.descricao) {
        filtro = this.descricao
      }

      await this.$loadResource({
        limit: this.perPage,
        page: this.page,
        filter: filtro,
      })
    },

    async detalhes(functionToggleDetails) {
      await functionToggleDetails()
    },

    async show() {
      await this.$refs.finder.show()
      this.$bvModal.show(this.id)
    },

    async grupoSelect(item) {
      this.$emit("onselect", item)
      await this.$bvModal.hide(this.id)
    },
    cancelar() {
      this.$emit("close")
    },
  },
}
</script>
